
// Emits: need_refresh

<template>

	<div>

		<loadDia ref="load" :essence="essence" v-on:load="load_from_foreign_storage"/>
		<deleteDia ref="delete_one" :essence="essence" v-on:delete="do_delete_one"/>

		<saveDia ref="save" :essence="essence" v-on:save="save_to_foreign_storage" v-on:reset="() => $emit('save_reset')">

			<template v-slot:additional_controls>

				<slot name="additional_save_controls"/>

			</template>

		</saveDia>

		<b-card class="vqb-card">

			<b-row>

				<b-col cols="10"><h4 class="card-title">{{ name }}</h4></b-col>
				<b-col align="right"><slot name="nav_buttons"/></b-col>

			</b-row>

			<slot name="additional_row_before_nav_items"/>

			<b-row>
			<b-col cols="12">

				<b-nav pills>

					<b-nav-item v-if="!$root.readonly" v-on:click="save" variant="primary">Сохранить</b-nav-item>
					<b-nav-item v-on:click="load" variant="primary">Загрузить</b-nav-item>
					<b-nav-item v-if="show_apply_button" v-on:click="apply" variant="primary">Применить</b-nav-item>
					<b-nav-item v-if="! show_apply_button" v-on:click="cancel" variant="primary">Отменить</b-nav-item>
					<b-nav-item v-on:click="clear" variant="primary">Очистить</b-nav-item>
					<b-nav-item v-if="!$root.readonly" v-on:click="delete_one" variant="primary">Удалить</b-nav-item>
					<slot name="nav_items"/>

				</b-nav>

			</b-col>
			</b-row>

			<b-row>
			<b-col cols="12">

				<v-query ref="query" :rules="rules" :labels="labels" v-model="query"/>

			</b-col>
			</b-row>

		</b-card>
	
	</div>

</template>

<script>

import api from "../../api"
import base from "./base"
import deleteDia from "./delete"
import saveDia from "./save"
import loadDia from "./load"

export default
{
	props :
	{
		essence : String,
		attrs : Array,
		storage_name_filters : { type : String, default : () => null },
		storage_name_filters_name : { type : String, default : () => null },
		query_key_prefix : { type : String, default : () => null },
		exceptions_for_query_key_prefix : { type : Array, default : () => [] },
		additional_rules : { type : Array, default : () => [] },
		with_cancel_button : { type : Boolean, default : () => false },
	},

	components :
	{
		deleteDia,
		saveDia,
		loadDia,
	},

	mounted()
	{
		this.$emit("ready")
	},

	data()
	{
		return {

			query : {},
			saved_query : {},
			saved_query_json : "{}",
			rules : [],
			labels : base.labels,
			name : "Фильтры",
			applied : false,
			show_apply_button : true,

		}
	},

	methods :
	{
		// #############################################################################
		// Модальные окна

		delete_one()
		{
			this.$refs.delete_one.execute()
		},

		save()
		{
			if(! base.check(this))
			{
				api.show_notification(this, "Фильтр некорректен")

				return
			}

			this.$refs.save.execute()
		},

		load()
		{
			this.$refs.load.execute()
		},

		// #############################################################################

		get_query(additional_query = null, raw_query = null, in_json = true, extra = {}, and_query = null, saved = false)
		{
			if(saved)
			{
				if(in_json)
					return this.saved_query_json

				return this.saved_query
			}

			var query = base.compile_query(this.rules, this.query, this.$props.query_key_prefix, this.$props.exceptions_for_query_key_prefix)

			if(Object.keys(query).length)
			{
				if(additional_query && and_query == null)
					query = { "and" : [ query, { "additional_query" : additional_query } ] }
				else if(additional_query == null && and_query)
					query = { "and" : [ query, and_query ] }
				else if(additional_query && and_query)
					query = { "and" : [ query, and_query, { "additional_query" : additional_query } ] }
			}
			else
			{
				if(additional_query && and_query == null)
					query = { "and" : [ { "additional_query" : additional_query } ] }
				else if(additional_query == null && and_query)
					query = { "and" : [ and_query ] }
				else if(additional_query && and_query)
					query = { "and" : [ and_query, { "additional_query" : additional_query } ] }
			}

			if(raw_query)
				query.raw = raw_query

			query.extra = extra

			this.saved_query = query
			this.saved_query_json = JSON.stringify(query)

			if(in_json)
				return this.saved_query_json

			return this.saved_query
		},

		refresh(attrs = null)
		{
			if(attrs == null)
				attrs = this.$props.attrs

			this.clear(false)

			return base.create_rules(this, this.$props.essence, attrs, this.$props.additional_rules)
				.then(rules => { this.rules = rules })
		},

		clear(with_refresh = true)
		{
			this.name = "Фильтры"

			this.$refs.query.$refs.main_group.$refs.attr_select.clearSelection()
			this.query["children"] = []
			this.applied = false

			if(with_refresh)
			{
				this.$emit("need_refresh", { reason : "clear" })

				if(this.with_cancel_button)
					this.cancel()
			}
		},

		apply()
		{
			if(! base.check(this))
				return

			if(this.with_cancel_button)
				this.show_apply_button = false

			this.applied = true

			this.$emit("need_refresh", { reason : "apply" })
		},

		// Для with_cancel_button == true
		apply_finish()
		{
			this.show_apply_button = true
		},

		cancel()
		{
			this.$emit("cancel")

			this.show_apply_button = true
		},

		// #############################################################################
		// Загрузка

		load_from_query(query, with_need_refresh = true)
		{
			this.query = 
			{
				"logicalOperator": "all",
				"children": [],
			}

			var new_query = base.load(this.rules, query, this.query_key_prefix)
			
			this.query = new_query

			this.$nextTick(() =>
				{
					if(query != "{}")
					{
						this.applied = true

						if(with_need_refresh)
							this.$emit("need_refresh", { reason : "apply" })
					}
				})

			return ( query != "{}" )
		},

		exist_tab_local()
		{
			const exist = this.$props.storage_name_filters != null && api.storage.exist_local(this, this.$props.storage_name_filters) != null

			return exist
		},

		load_from_local_storage(with_need_refresh = true)
		{
			if(this.$props.storage_name_filters_name != null)
				this.name = api.storage.get(this, this.$props.storage_name_filters_name, "Фильтры", String)

			if(this.$props.storage_name_filters != null)
			{
				const query = api.storage.get(this, this.$props.storage_name_filters, "{}", String)

				return this.load_from_query(query, with_need_refresh)
			}

			return false
		},

		load_from_foreign_storage(desc, with_need_refresh = true)
		{
			if(desc.name != null)
				this.name = "Фильтры: " + desc.name

			this.load_from_query(desc.query, false)

			if(with_need_refresh)
			{
				this.applied = true
				this.$emit("need_refresh", { reason : "apply" })
			}
		},

		// #############################################################################
		// Сохранение
		
		save_to_local_storage()
		{
			if(this.$props.storage_name_filters != null)
				api.storage.set(this, this.$props.storage_name_filters, JSON.stringify(base.compile_query(this.rules, this.query, this.$props.query_key_prefix, this.$props.exceptions_for_query_key_prefix)))

			if(this.$props.storage_name_filters_name != null)
				api.storage.set(this, this.$props.storage_name_filters_name, this.name)
		},

		save_to_foreign_storage(desc)
		{
			const query = base.compile_query(this.rules, this.query)
			var params = { name : desc.name, filter : JSON.stringify(query), essence : this.$props.essence }
			var success_func = response =>
				{
					this.$emit("save_to_foreign_storage", response.id)

					this.name = "Фильтры: " + desc.name

					api.show_notification(this, "Фильтр сохранен")

					this.$refs.save.$refs.modal.my_hide()
				}

			api.call(this, "filters", "save", params, success_func,
				( self, err ) =>
				{
					if(err.exception == "ObjectExists")
						this.$bvModal.msgBoxConfirm(
							"Фильтр с таковым наименованием уже существует. Заменить?",
							{
								title : "Замена",
								okVariant : "danger",
								okTitle : "Да",
								cancelVariant : "outline-primary-secondary",
								cancelTitle : "Нет",
								hideHeaderClose : false,
								centered : true
							})
						.then(
							value =>
							{
								if(value)
								{
									params.force_if_possible = true

									api.call(this, "filters", "save", params, success_func)
								}
								else
								{
									this.name_state = false
									this.name_feedback = "Фильтр с таковым наименованием уже существует"
								}
							})
					else
						api.show_error_box(self, err, err.description)
				})
		},

		// #############################################################################
		// Удаление

		do_delete_one(ev)
		{
			Promise.all(
				ev.map(filter => api.call(this, "filters", "delete", { id : filter.value }, () => api.show_notification(this, "Фильтр удален")))
			)
			.then(() => {
				ev.forEach((filter) => {
					if(this.name == "Фильтры: " + filter.text)
						this.name = "Фильтры"
				})
			})
		},
	}
}

</script>

<style scoped>
* >>> .vqb-card
{
	border: none;
}
</style>

